import { RestaurantResponse } from '../Restaurants/models';

export type ProductAssignmentForm = {
  itemsVolume: number | null;
  restaurant: RestaurantResponse | null;
};

export enum ScannerType {
  SCANDIT = 'scandit',
  BLUETOOTH = 'bluetooth',
  HID = 'hid',
  BACKGROUND = 'background',
  NONE = 'none',
}

export enum VisibleModal {
  PRODUCTS_ASSIGNMENT_SUCCESS,
  CANCEL_PRODUCTS_ASSIGNMENT,
  ASSIGN_PRODUCTS_FROM_CSV,
  REASSIGN_BETWEEN_RESTAURANTS,
  FACTORY_RESET_SCANNER,
  POWER_TIMEOUT_TIMER,
  BLUETOOTH_SCANNER_SETTINGS,
  HID_SCANNER_SETTINGS,
  SERIAL_SCANNER_SETTINGS,
  BACKGROUND_SCANNER_SETTINGS,
  SCAN_INFO,
}
